<template>
  <div
    class="table-item-content"
    v-if="props.row">
    <div class="table-item-row">
      <div
        class="table-item-content-icon"
        v-if="
          props.row.validation?.label === 'Réalisé' &&
          !props.row.validation?.nombreTentativesRestantes
        ">
        <IconValidate20Green />
      </div>
      <div class="table-item-content-text">
        <span>{{
          props.row.validation?.nombreTentativesRestantes
            ? 'Repasser'
            : (props.row.validation?.label ?? 'Non requis')
        }}</span>
      </div>
    </div>
    <div
      class="table-item-row"
      v-if="props.row.validation?.nombreBonnesReponses">
      <div
        v-bind:class="`table-item-content-card ${props.row.validation?.seuil && props.row.validation.nombreBonnesReponse > props.row.validation.seuil ? 'table-item-content-card-blue' : ''}`">
        <span
          >Note : {{ props.row.validation.nombreBonnesReponses }}/{{
            props.row.validation.nbreQuestions
          }}</span
        >
      </div>
    </div>
    <div
      class="table-item-row"
      v-if="props.row.validation?.nombreTentativesRestantes">
      <div class="table-item-content-card table-item-content-card-light-blue">
        <span>
          Nombre de tentatives restantes :
          {{ props.row.validation.nombreTentativesRestantes
          }}{{
            props.row.validation.nombreTentatives
              ? `/${props.row.validation.nombreTentatives}`
              : ''
          }}</span
        >
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { Synthese } from '@/types/participant/formations-details-types';
  import IconValidate20Green from '@/assets/img/refonte/icons/information/icon-validate-20-green.svg?component';

  const props = withDefaults(
    defineProps<{
      row: Synthese;
    }>(),
    {}
  );
</script>

<style lang="scss" scoped>
  .table-item-content {
    @apply flex flex-col;
    min-height: 20px;
    gap: 8px;
    padding-top: 2px;

    .table-item-row {
      @apply flex items-center;
      gap: 8px;
    }
    .table-item-content-icon {
      @apply flex shrink-0 items-center justify-center;
      width: 20px;
      height: 20px;
    }
    .table-item-content-text {
      @apply flex-grow text-refonte-black;
      font-size: 14px;
      font-weight: 400;
      line-height: 125%;
    }
    .table-item-content-card {
      @apply bg-accent-500 text-core-100;
      border-radius: 4px;
      padding: 4px 8px;
      font-size: 11px;
      font-weight: 400;
    }
    .table-item-content-card-blue {
      @apply bg-refonte_blue-600;
    }
    .table-item-content-card-light-blue {
      @apply bg-refonte_blue-100 text-core-800;
      margin-bottom: 2px;
    }
  }
</style>
